export function findModel(vnode) {
  if (!vnode.data) {
    return null;
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model;
  }

  // return (!!vnode.data.directives && find(vnode.data.directives, d => d.name === "model")
  // console.log('find model: ', vnode.data.directives.find((d) => d.name === 'model'))
  return vnode.data.directives.find((d) => d.name === 'model');
}

export function validatorFound(vnode) {
  //const modelName = findModel(vnode).expression;
  const validator = vnode.context.$root.$validator;

  const foundObjects = validator.filter((v) => v.compId === vnode.data.attrs.id);

  return foundObjects.length > 0;
}

export function arrayUnique(array) {
  var a = array.concat();
  for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
          if(a[i] === a[j])
              a.splice(j--, 1);
      }
  }

  return a;
}
